import { messaging } from "./firebase";

// const VAPID_KEY = "BPiEcMXEvMP0bKNhGTdseKWWzlFCI94_A6cAjJb3zi5HGwGCsXw4oYsOFnSN4Ktq6DazArCUKQAGdR1OII5WuJA";

const VAPID_KEY = "BOgLGMdRmAzOWV2Xs7qC0LHoCZ71R5hc_C6jR_6ZI_n2gxyRLWAeknHTlXydsx_tCXlJSb3Jo7m-jbWS_1w0OS0";

export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("Notification permission denied");
            return null;
        }

        const token = await messaging.getToken({ vapidKey: VAPID_KEY });
        if (token) {
            localStorage.setItem('device_token', token);
            return token;
        } else {
            console.warn("No FCM token — check VAPID key or service worker");
            return null;
        }
    } catch (err) {
        console.error("FCM Error:", err);
        return null;
    }
};
